import React from "react";

export const EmptyState = ({ label = "Nothing on the calendar yet" }) => {
  return (
    <div
      className="flex flex-col items-center justify-center text-center py-10 px-6 rounded-2xl"
      style={{
        border: "1px dashed rgba(212, 175, 55, 0.18)",
        background: "linear-gradient(180deg, rgba(212,175,55,0.02), rgba(212,175,55,0.005))",
      }}
      data-testid="empty-state"
    >
      <div
        className="w-14 h-14 rounded-full flex items-center justify-center mb-4"
        style={{
          background: "radial-gradient(circle at 30% 30%, rgba(212,175,55,0.18), rgba(212,175,55,0.02))",
          border: "1px solid rgba(212,175,55,0.25)",
        }}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 3l1.8 5.6L19.5 9 15 12.6 16.5 18 12 14.9 7.5 18 9 12.6 4.5 9l5.7-.4L12 3z"
            stroke="#D4AF37"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <p className="font-serif text-lg text-[#F5F5F5]/90">{label}</p>
      <p className="text-xs mt-2 text-[#8E8E93] tracking-wider uppercase">
        A quiet moment — reserve one
      </p>
    </div>
  );
};

export default EmptyState;
